<div class="sidebar-logo">
  <a routerLink="/">
    <img src="./assets/images/logo.jpg" alt="logo" height="19" width="34"/>
    <h1>Админ. панель</h1>
  </a>
</div>